export default __webpack_public_path__ + "static/media/Savannah_9781408327968.53f0f4ef.jpg";